import React from 'react';
import { Link } from 'react-router-dom'
import Layout from '../../components/Layout'
import strings from '../../components/Language';
import "./profile.scss"
import _ from 'lodash';
import Avatar1 from './../../assets/images/icons/avatar1.svg';
import {
	IconLink, IconWallet, IconUsers, IconBook, IconZap, IconGift, IconCrown, IconShare,
	IconBell, IconShield, IconChat, IconSettings, IconChevronRight, IconCopy,
} from '../../components/Icons';

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import LoaderContext from '../../components/Loader/LoaderContext.js';

class ProfileScreen extends React.Component {
	static contextType = LoaderContext;

	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			user_data: {},
			contact_us_url: "https://t.me/ctsbot_info",
		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			this.setState({ access_token: token });
			setTimeout(() => {
				this.getData();
			});
		}
	}

	getData() {
		const { setLoading } = this.context;
		var self = this;
		setLoading(true);
		axios({
			method: 'GET',
			url: api.profile_show,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage(),
			}
		}).then(function (ress) {
			if (ress.data && ress.data.error === 200) {
				self.setState({ user_data: ress.data.data });
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function () {
			setLoading(false);
		});
	};

	copyText(text) {
		navigator.clipboard.writeText(text);
		toast.success(strings.copy_id);
	}

	renderMenuRow = (item) => {
		const isActiveAccount = !!(this.state.user_data && this.state.user_data.status);
		const Icon = item.icon;
		const content = (
			<>
				<span className='pf-row-icon'><Icon size={20} /></span>
				<span className='pf-row-label'>{item.label}</span>
				<span className='pf-row-chevron'><IconChevronRight size={18} /></span>
			</>
		);

		if (item.external) {
			return (
				<a key={item.key} href={item.href} target="_blank" rel="noreferrer" className='pf-row'>{content}</a>
			);
		}
		if (item.requiresActive && !isActiveAccount) {
			return (
				<button key={item.key} type='button' className='pf-row' onClick={() => toast.warning(strings.need_to_active_account)}>{content}</button>
			);
		}
		return (
			<Link key={item.key} to={item.to} className='pf-row'>{content}</Link>
		);
	}

	render() {
		const userData = this.state.user_data || {};
		const status = userData.status_data || {};
		const sections = [
			{
				title: strings.section_account, items: [
					{ key: 'api-bind', icon: IconLink, label: strings.api_bind, to: '/apibind' },
					{ key: 'wallet', icon: IconWallet, label: strings.wallet, to: '/wallet' },
					{ key: 'team', icon: IconUsers, label: strings.team, to: '/team' },
					{ key: 'tutorial', icon: IconBook, label: strings.tutorial, to: '/tutorial' },
				]
			},
			{
				title: strings.section_trading, items: [
					{ key: 'autotrade', icon: IconZap, label: strings.AutoTrade, to: '/auto-trade' },
					{ key: 'rewards', icon: IconGift, label: strings.rewards, to: '/reward' },
					{ key: 'affiliate', icon: IconCrown, label: strings.affiliate_program, to: '/member-center' },
					{ key: 'share', icon: IconShare, label: strings.share, to: '/invite-link', requiresActive: true },
				]
			},
			{
				title: strings.section_support, items: [
					{ key: 'notification', icon: IconBell, label: strings.Notifications, to: '/notifications' },
					{ key: 'security', icon: IconShield, label: strings.security_centre, to: '/security-centre' },
					{ key: 'contact', icon: IconChat, label: strings.contact_us, href: (this.state.contact_us_url || '/contact-us'), external: true },
					{ key: 'settings', icon: IconSettings, label: strings.system_setting, to: '/system-setting' },
				]
			},
		];

		return (
			<Layout data={{ "title": strings.Profile }}>
				<div className="pf-page">
					<section className='pf-card'>
						<div className='pf-head'>
							<Link to={'/profile-information'} className='pf-avatar-ring' aria-label={strings.profile_information}>
								<img className='pf-avatar' src={(userData && userData.avatar_url) ? userData.avatar_url : Avatar1} alt='' />
							</Link>
							<div className='pf-id-block'>
								<Link to={'/profile-information'} className='pf-name'>{userData.name ? userData.name : '--'}</Link>
								<div className='pf-uid'>
									<span>{strings.id}: {userData.username ? userData.username : '--'}</span>
									{userData.username ?
										<button type='button' className='pf-copy' aria-label={strings.code_copy} onClick={() => this.copyText(userData.username)}>
											<IconCopy size={14} />
										</button>
										: null}
								</div>
								<div className='pf-chips'>
									<span className='pf-chip'>{strings.Level}: {(userData.level_data && userData.level_data.name) ? userData.level_data.name : '-'}</span>
									<span className={'pf-chip ' + (status.identifier === 'active' ? 'pf-chip-up' : 'pf-chip-down')}>
										{status.name ? status.name : '-'}
									</span>
								</div>
							</div>
							<Link to={'/profile-information'} className='pf-open' aria-label={strings.profile_information}>
								<IconChevronRight size={20} />
							</Link>
						</div>
						<div className='pf-stats'>
							<div className='pf-stat'>
								<span className='pf-stat-k'>{strings.inviter_id_label}</span>
								<span className='pf-stat-v'>{userData.invitation_code ? userData.invitation_code : '-'}</span>
							</div>
							<div className='pf-stat'>
								<span className='pf-stat-k'>{strings.subscription_expires}</span>
								<span className='pf-stat-v'>{(userData.expired_at_data && userData.expired_at_data.expired_at) ? userData.expired_at_data.expired_at : '-'}</span>
							</div>
						</div>
					</section>

					{sections.map((section) => (
						<section key={section.title} className='pf-section'>
							<h2 className='pf-section-title'>{section.title}</h2>
							<div className='pf-list'>
								{section.items.map(this.renderMenuRow)}
							</div>
						</section>
					))}
				</div>
			</Layout>
		);
	}
}

export default ProfileScreen;
